export default __webpack_public_path__ + "static/media/airpod-left.7913b4e2.png";